const FILTER_TO_FILE_TYPE = {
  images: 'image',
  videos: 'video',
  audios: 'audio',
  files: 'file',
};

// Mapeia o chip de filtro da UI para o valor de file_type esperado pelo backend.
// 'all' (ou desconhecido) -> undefined (sem filtro).
export const mapFilterToFileType = filter => FILTER_TO_FILE_TYPE[filter];

export const CONTACT_MEDIA_FILTERS = [
  'all',
  'images',
  'videos',
  'audios',
  'files',
];
